export function extractPingsFromText(text: string): string[] {
  const pattern = /@[a-zA-Z0-9_.-]+/gm
  return text.match(pattern) || []
}
